module.exports = __webpack_public_path__ + "sinlogo-f190df9d.png";